// src/components/media/MediaThumb.tsx — what a file looks like in a grid: the server's thumbnail for a photo, an icon
// card for a PDF or a video (no thumbnail is made for those).
import { FileText, Film, ImageOff } from 'lucide-react';
import { useMediaBlob, type MediaItem } from '../../lib/media';

export function MediaThumb({ item, className = '' }: { item: Pick<MediaItem, 'kind' | 'thumbUrl' | 'fileName' | 'displayLabel'>; className?: string }) {
  const img = useMediaBlob(item.kind === 'IMAGE' ? item.thumbUrl : null);
  if (item.kind !== 'IMAGE') {
    const I = item.kind === 'PDF' ? FileText : Film;
    return (
      <div className={`grid h-full w-full place-items-center bg-ink-50 text-ink-400 ${className}`}>
        <div className="flex flex-col items-center gap-1">
          <I className="h-8 w-8" strokeWidth={1.5} />
          <span className="text-[10.5px] font-semibold uppercase tracking-[0.06em]">{item.kind === 'PDF' ? 'PDF' : 'Video'}</span>
        </div>
      </div>
    );
  }
  if (img.error) return <div className={`grid h-full w-full place-items-center bg-ink-50 text-ink-300 ${className}`}><ImageOff className="h-6 w-6" /></div>;
  if (!img.src) return <div className={`h-full w-full animate-pulse bg-ink-100 ${className}`} />;
  return <img src={img.src} alt={item.displayLabel ?? item.fileName} draggable={false} className={`h-full w-full object-cover ${className}`} />;
}
